import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';
import {
	findMacroContentNodes,
	type MacroContentNode,
} from '@confluence/macro-utils/entry-points/findMacroContentNodes.ts';

import useContributorsDataQuery, {
	type useContributorsDataQuery$data,
	type useContributorsDataQuery$variables,
} from '../hooks/__generated__/useContributorsDataQuery.graphql.ts';
import { composeMacroParamsForQuery } from '../hooks/useParsedMacroParams.ts';

const buildVariables = (
	node: MacroContentNode,
	contentId: string,
): useContributorsDataQuery$variables => {
	const macroParams = node.attrs?.parameters?.macroParams;

	return {
		contentId,
		contentStatus: ['current'],
		contributorsMacroParameters: macroParams ? composeMacroParamsForQuery(macroParams) : undefined,
	};
};

export const preloadContributorsData = async ({
	contentId,
	contentNodes,
}: {
	contentId: string;
	contentNodes: any;
}) => {
	const extensions = await findMacroContentNodes(contentNodes, 'contributors');
	if (extensions.length === 0) {
		return;
	}

	// eslint-disable-next-line check-preloaders/no-promise-all
	await Promise.all(
		extensions.map((extensionNode) => {
			const variables = buildVariables(extensionNode, contentId);
			return query<useContributorsDataQuery$data, useContributorsDataQuery$variables>({
				query: useContributorsDataQuery,
				variables,
				context: { single: true },
			});
		}),
	);
};
